module.exports = new __parcel__URL__("mining_defeat_label.edd94a1d.png").toString();